import { render, staticRenderFns } from "./MdDialogContent.vue?vue&type=template&id=68faa15e"
import script from "./MdDialogContent.vue?vue&type=script&lang=js"
export * from "./MdDialogContent.vue?vue&type=script&lang=js"
import style0 from "./MdDialogContent.vue?vue&type=style&index=0&id=68faa15e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports